import { SystemLogTypes } from 'generated/graphql-types';
import {
   EagerSelectState,
   createEagerSelectAdapter,
   createEagerSelectReducer,
} from '../../select/eager-select/eager-select-reducer';
import { SystemLogTypeOption } from '../system-logs-type-option.interface';
import { systemLogTypeOptionActions } from './system-logs-type-select-option.actions';

export const systemLogTypeOptionFeatureKey = 'systemLogTypeOptions';

export type SystemLogTypeOptionState = EagerSelectState<SystemLogTypeOption>;

const adapter = createEagerSelectAdapter<SystemLogTypeOptionState, SystemLogTypeOption>({
   featureKey: systemLogTypeOptionFeatureKey,
   selectId: (type: SystemLogTypeOption) => {
      return type.systemLogTypeId ?? '';
   },
});

export const systemLogTypeOptionSelectors = adapter.getSelectors(filterTypeNameOption);

const initialState = adapter.getInitialState();

export const systemLogTypeOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   systemLogTypeOptionActions.search,
   systemLogTypeOptionActions.searchReset,
   systemLogTypeOptionActions.loadFromApi,
   systemLogTypeOptionActions.loadFromApiSuccess,
   systemLogTypeOptionActions.loadFromApiFailure
);

export function filterTypeNameOption<T extends SystemLogTypeOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   const filteredOptions: T[] = Object.values(SystemLogTypes)
      .filter((name) => {
         if (searchText) {
            return name.toLowerCase().includes(searchText.toLowerCase());
         } else {
            return true;
         }
      })
      .map((name) => {
         return { name } as unknown as T;
      });

   return filteredOptions;
}
